import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const MatchList = ({ matchList, isUpcomming }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { language } = useSelector((state) => state.language);

  console.log("matchListmatchListmatchListmatchList111", matchList)

  const matches = [
    {
      time: "12:30",
      matchDate: "26 Aug",
      teams: [
        {
          name: "Paris Saint-Germain",
          logo: require("../../../assets/images/clubs/paris.png"),
        },
        {
          name: "Stade Brestois 29",
          logo: require("../../../assets/images/clubs/sb29.png"),
        },
      ],
      score: [2, 1],
      points: 2,
      chartIcon: "../../../assets/images/icons/bar-chart.svg",
      rank: 24,
    },
    {
      time: "14:00",
      matchDate: "27 Aug",
      teams: [
        {
          name: "Racing Club de Lens",
          logo: require("../../../assets/images/clubs/rcl.png"),
        },
        {
          name: "Olympique Lyonnais",
          logo: require("../../../assets/images/clubs/rfef.png"),
        },
      ],
      score: [3, 1],
      points: 10,
      chartIcon: "../../assets/images/icons/bar-chart.svg",
      rank: 22,
    },
  ];

  return (
    <div class="overflow-x-auto">
      <table class="table table-row-hover w-full">
        <thead class="border-b light-border">
          <tr>
            <th>{t("time")}</th>
            <th>{t("teams")}</th>
            {isUpcomming ? null :
              <th class="text-center">{t("score")}</th>}
            {isUpcomming ? null :
              <th class="text-center">{t("pts")}</th>}
            {isUpcomming ? null :
              <th class="text-center">{t("stats")}</th>}
            {isUpcomming ? null :
              <th class="text-center">{t("bet")}</th>}
          </tr>
        </thead>

        <tbody class="divide-y divide-gray-200 [&_tr_td]:align-top">
          {matchList && matchList?.map((match, index) => {
            const trendClass = match.points > 5 ? "up" : "down";
            return (
              <tr key={index}>
                <td width="24">
                  <p className="time text-xs font-secondary text-nowrap">
                    {match.matchTime}
                  </p>
                  <p className="date text-xs font-secondary text-nowrap text-gray-500">
                    {match.matchDate}
                  </p>
                </td>
                <td>
                  <div
                    className="flex max-sm:flex-wrap items-center gap-3"
                    onClick={() => navigate(`/${language}/fixtures/history`)}
                  >
                    <ul className="flex -space-x-2 rtl:space-x-reverse">
                      {match?.teams.map((team, teamIndex) => (
                        <li
                          key={teamIndex}
                          className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white"
                        >
                          <img
                            className="size-7 object-contain dark:border-gray-800"
                            src={team.logo}
                            alt={team.name}
                          />
                        </li>
                      ))}
                    </ul>
                    <div>
                      <p className="uppercase">{match.teams[0].name}</p>
                      <p className="uppercase text-gray-400">
                        {match.teams[1].name}
                      </p>
                    </div>
                  </div>
                </td>
                <td className="text-nowrap">
                  <div className="score-result flex flex-col items-center gap-1">
                    {/* <span className="active">{match.score[0]}</span> */}
                    {/* <span>{match.score[1]}</span> */}
                  </div>
                </td>
                {isUpcomming ? null :
                  <td className="text-nowrap">
                    <div className="point-result flex flex-col items-center gap-1">
                      <span className={trendClass}>{match.points}</span>
                    </div>
                  </td>}
                {isUpcomming ? null :
                  <td className="text-center">
                    <img src={match.chartIcon || "../../assets/images/icons/bar-chart.svg"} alt="Chart" className="inline" />
                  </td>}
                {isUpcomming ? null :
                  <td className="text-center font-medium">{match.rank}</td>}
              </tr>
            );
          })}
          {matches && matches?.map((match, index) => {
            // Auto Trend Logic
            const trendClass = match.points > 5 ? "up" : "down";

            return (
              <tr key={index}>
                <td width="24">
                  <p className="time text-xs font-secondary text-nowrap">
                    {match.time}
                  </p>
                  <p className="date text-xs font-secondary text-nowrap text-gray-500">
                    {match.matchDate}
                  </p>
                </td>

                <td>
                  <div
                    className="flex max-sm:flex-wrap items-center gap-3"
                    onClick={() => navigate(`/${language}/fixtures/history`)}
                  >
                    <ul className="flex -space-x-2 rtl:space-x-reverse">
                      {match?.teams.map((team, teamIndex) => (
                        <li
                          key={teamIndex}
                          className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white"
                        >
                          <img
                            className="size-7 object-contain dark:border-gray-800"
                            src={team.logo}
                            alt={team.name}
                          />
                        </li>
                      ))}
                    </ul>
                    <div>
                      <p className="uppercase">{match.teams[0].name}</p>
                      <p className="uppercase text-gray-400">
                        {match.teams[1].name}
                      </p>
                    </div>
                  </div>
                </td>
                {isUpcomming ? null :
                  <td className="text-nowrap">
                    <div className="score-result flex flex-col items-center gap-1">
                      <span className="active">3</span>
                      <span>1</span>
                    </div>
                  </td>}
                {isUpcomming ? null :
                  <td className="text-nowrap">
                    <div className="point-result flex flex-col items-center gap-1">
                      <span className={trendClass}>5</span>
                    </div>
                  </td>}
                {isUpcomming ? null :
                  <td className="text-center">
                    <img src="../../../assets/images/icons/bar-chart.svg" alt="Chart" className="inline" />
                  </td>}
                {isUpcomming ? null :
                  <td className="text-center font-medium">22</td>
                }
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MatchList;
